// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Spread$Showside from "./Spread.bs.js";
import * as ScrollDirection$Showside from "./ScrollDirection.bs.js";
function HideOnScroll(Props) {
  var enabledOpt = Props.enabled;
  var hideOnOpt = Props.hideOn;
  var scrollableRef = Props.scrollableRef;
  var children = Props.children;
  var threshold = Props.threshold;
  var onChange = Props.onChange;
  var enabled = enabledOpt !== undefined ? enabledOpt : true;
  var hideOn = hideOnOpt !== undefined ? hideOnOpt : /* Down */1;
  var initialDirection = hideOn === /* Up */0 ? /* Down */1 : /* Up */0;
  var scrollElement = Belt_Option.flatMap(scrollableRef, function (ref) {
    return Caml_option.nullable_to_opt(ref.current);
  });
  var usingWindow = Belt_Option.isNone(scrollElement);
  var match = ScrollDirection$Showside.useScrollable(!usingWindow, scrollElement, initialDirection, threshold, undefined);
  var match$1 = ScrollDirection$Showside.useWindow(usingWindow, undefined, initialDirection, threshold, undefined);
  var scrollDirection = usingWindow ? match$1[0] : match[0];
  var scrollDirection$1 = enabled ? scrollDirection : hideOn;
  React.useEffect(function () {
    if (enabled) {
      Belt_Option.forEach(onChange, function (change) {
        Curry._1(change, scrollDirection$1 !== hideOn);
      });
    }
  }, [scrollDirection$1]);
  return React.createElement(Spread$Showside.make, {
    props: {
      show: scrollDirection$1 !== hideOn || !enabled
    },
    children: children
  });
}
HideOnScroll.displayName = "HideOnScroll";
var make = React.memo(HideOnScroll);
export { make };
/* make Not a pure module */